import { JsonWrapper } from 'src/services/JsonWrapper';

import { Logger } from 'src/utils/logger';

class LocalStorage {
  public static get: <T = unknown>(key: string, json?: boolean) => T | null = (
    key,
    json = false,
  ) => {
    try {
      const data = localStorage.getItem(key);

      return json ? JsonWrapper.toJson(data) : (data as any);
    } catch (e) {
      Logger.error('Failed to access local storage', 'LocalStorage', e);
    }

    return null;
  };

  public static set = (key: string, value: any): void => {
    try {
      const data = typeof value === 'string' ? value : JsonWrapper.toString(value);

      localStorage.setItem(key, data);
    } catch (e) {
      Logger.error('Failed to access local storage', 'LocalStorage', e);
    }
  };

  public static remove = (key: string): void => {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      Logger.error('Failed to access local storage', 'LocalStorage', e);
    }
  };
}

export { LocalStorage };
